
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2PQ94", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $2TjtA = parcelRequire("2TjtA");

const $8732b95d75640165$export$91aed7d8dfc4aa1f = (props)=>{
    const $ = (0, $bDgLe.c)(15);
    const t0 = props.node?.localId;
    let t1;
    if ($[0] !== props.contentId || $[1] !== t0) {
        t1 = {
            contentId: props.contentId,
            nodeLocalId: t0
        };
        $[0] = props.contentId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props.clientAnnotationProvider || $[4] !== props.clientExtensionHandlers || $[5] !== props.clientHydrationReady || $[6] !== props.contentId || $[7] !== props.contentMode || $[8] !== props.enableHydrationBridge || $[9] !== props.extensionHandlers || $[10] !== props.node) {
        t2 = props.enableHydrationBridge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TjtA.NBMRendererHydrationBridge), {
            clientAnnotationProvider: props.clientAnnotationProvider,
            clientExtensionHandlers: props.clientExtensionHandlers,
            clientHydrationReady: props.clientHydrationReady,
            contentId: props.contentId,
            contentMode: props.contentMode,
            extensionHandlers: props.extensionHandlers,
            node: props.node
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TjtA.NBMRendererServer), {
            contentId: props.contentId,
            contentMode: props.contentMode,
            node: props.node
        });
        $[3] = props.clientAnnotationProvider;
        $[4] = props.clientExtensionHandlers;
        $[5] = props.clientHydrationReady;
        $[6] = props.contentId;
        $[7] = props.contentMode;
        $[8] = props.enableHydrationBridge;
        $[9] = props.extensionHandlers;
        $[10] = props.node;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== t1 || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE,
            attributes: t1
        }, t2);
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
};
module.exports["LegacyContentExtensionHandler"] = $8732b95d75640165$export$91aed7d8dfc4aa1f;

});

parcelRegister("gmxua", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");





var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $eNbr2 = parcelRequire("eNbr2");


var $jNKuq = parcelRequire("jNKuq");


var $8Ij3v = parcelRequire("8Ij3v");


var $hMRhJ = parcelRequire("hMRhJ");


var $2TjtA = parcelRequire("2TjtA");


var $hBmKH = parcelRequire("hBmKH");


var $iy2dR = parcelRequire("iy2dR");


var $KndLU = parcelRequire("KndLU");


var $gGHFp = parcelRequire("gGHFp");





var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");

const $747431ca82b27ac2$export$752c2a143fc251c1 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { contentMode: contentMode, node: node } = props;
    // Inside a bridged recursive-SSR subtree this LCM is already within a renderer that holds the
    // manifests, so it inherits them instead of building and populating a factory of its own. On a
    // client-only page or an SPA transition there is nothing to inherit and it keeps its own.
    const insideNestedLcmHierarchy = (0, $cozmU.useContext)((0, $hBmKH.NestedLcmHierarchyContext));
    const spaceId = (0, $7QM6o.useSpaceId)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType = 'page'] = (0, $ep3mz.useContentType)();
    const { environment: environment, cloudId: cloudId, userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $cozmU.useContext)((0, $hMRhJ.RendererExtensionContext));
    // A child of the ambient factory rather than the factory itself: `mergeDataProviders` mutates
    // whatever it is given, so reusing the page factory directly would swap the page's own
    // media/card/task providers and notify every subscriber on the page.
    const derivedProviderFactory = (0, $KndLU.useNestedLcmProviderFactory)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { mode: editorContentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const effectiveContentMode = contentMode ?? editorContentMode;
    const { adfDocument: adfDocument, appearance: appearance } = (0, $2TjtA.resolveNBMRenderConfig)(node);
    /**
   * Both context functions use classic renderer types that are currently exposed as `any`.
   */ const extensionHandlers = (0, $cozmU.useMemo)(()=>getExtensionHandlers?.({
            adf: adfDocument,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            appearance: 'full-width',
            referentialityDataSourceProvider: {}
        }, createAnalyticsEvent), [
        adfDocument,
        contentId,
        contentType,
        createAnalyticsEvent,
        getExtensionHandlers,
        spaceKey
    ]);
    const annotationProvider = (0, $8Ij3v.useRendererAnnotationProviderOptions)({
        pageId: contentId ?? '',
        validAnnotationsCallback: ()=>{},
        triggerAnalyticsEvent: createAnalyticsEvent,
        updateDocument: ()=>{},
        isArchived: false
    });
    const getDataProviders = (0, $cozmU.useCallback)(()=>{
        const providerFactory = (0, $eNbr2.default).create({});
        if (populateExtensionProviders) populateExtensionProviders(providerFactory, {
            activationId: activationId,
            accountId: userId,
            cloudId: cloudId,
            containerId: spaceKey,
            contentId: contentId,
            contentType: contentType,
            createAnalyticsEvent: createAnalyticsEvent,
            environment: environment,
            extensionHandlers: extensionHandlers,
            intl: intl,
            spaceKey: spaceKey,
            spaceId: spaceId
        });
        return providerFactory;
    }, [
        populateExtensionProviders,
        activationId,
        userId,
        cloudId,
        spaceKey,
        contentId,
        contentType,
        createAnalyticsEvent,
        environment,
        extensionHandlers,
        intl,
        spaceId
    ]);
    const { eventHandlers: eventHandlers, onSetLinkTarget: onSetLinkTarget } = (0, $jNKuq.useExternalLinkHandlers)();
    (0, $iy2dR.useLegacyContentMacroRendererAnalytics)({
        adfDocument: adfDocument,
        contentId: contentId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2TjtA.NBMRendererContent), {
        allowAnnotations: true,
        annotationProvider: annotationProvider,
        appearance: appearance,
        contentId: contentId,
        contentMode: effectiveContentMode,
        dataProviders: insideNestedLcmHierarchy ? derivedProviderFactory : getDataProviders(),
        adfDocument: adfDocument,
        eventHandlers: eventHandlers,
        onSetLinkTarget: onSetLinkTarget
    });
});


const $90e09e5972c02f7f$export$91aed7d8dfc4aa1f = (props)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CC_EDITOR_AI,
        attributes: {
            contentId: contentId,
            nodeLocalId: props.node?.localId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $747431ca82b27ac2$export$752c2a143fc251c1), {
        contentMode: props.contentMode,
        node: props.node
    }));
};
module.exports["LegacyContentExtensionHandler"] = $90e09e5972c02f7f$export$91aed7d8dfc4aa1f;

});

parcelRegister("8Ij3v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4sEGL = parcelRequire("4sEGL");


var $jzubZ = parcelRequire("jzubZ");


var $cZa7r = parcelRequire("cZa7r");


var $cR8Mr = parcelRequire("cR8Mr");

const $0880ee54bb9fbae3$export$8a100b863f90f2c5 = ({ pageId: pageId, validAnnotationsCallback: validAnnotationsCallback, triggerAnalyticsEvent: triggerAnalyticsEvent, updateDocument: updateDocument, isArchived: isArchived })=>{
    const supportsExtensionBlockComments = (0, $4sEGL.useNativeEmbedCommentSupport)();
    const { setSelectionProps: setSelectionProps, setViewProps: setViewProps, setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const isBlockNodeSupported = (0, $cozmU.useCallback)((node)=>(0, $cR8Mr.isRendererExtensionCommentBlockNodeSupported)(node, supportsExtensionBlockComments), [
        supportsExtensionBlockComments
    ]);
    const canCreateCommentOnBlockNode = (0, $cozmU.useCallback)((node)=>(0, $cR8Mr.isExtensionCommentBlockNodeSupported)(node, supportsExtensionBlockComments), [
        supportsExtensionBlockComments
    ]);
    return (0, $cozmU.useMemo)(()=>({
            inlineComment: {
                ...(0, $jzubZ.getRendererInlineCommentOptions)({
                    pageId: pageId,
                    validAnnotationsCallback: validAnnotationsCallback,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    setSelectionProps: setSelectionProps,
                    setHoverProps: setHoverProps,
                    setViewProps: setViewProps,
                    updateDocument: updateDocument,
                    isArchived: isArchived
                }),
                isBlockNodeSupported: isBlockNodeSupported,
                canCreateCommentOnBlockNode: canCreateCommentOnBlockNode
            },
            annotationManager: annotationManager
        }), [
        isBlockNodeSupported,
        canCreateCommentOnBlockNode,
        pageId,
        validAnnotationsCallback,
        triggerAnalyticsEvent,
        setSelectionProps,
        setHoverProps,
        setViewProps,
        updateDocument,
        isArchived,
        annotationManager
    ]);
};
module.exports["useRendererAnnotationProviderOptions"] = $0880ee54bb9fbae3$export$8a100b863f90f2c5;

});

parcelRegister("4sEGL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dfHaf = parcelRequire("dfHaf");


var $c6zyu = parcelRequire("c6zyu");

const $937107406d6c3d9b$var$getDisabledSnapshot = ()=>(0, $dfHaf.noNativeEmbedCommentSupport);
const $937107406d6c3d9b$export$5ad16a2502716cba = ()=>{
    const store = (0, $c6zyu.getNativeEmbedCommentSupportStore)();
    return (0, $cozmU.useSyncExternalStore)(store.subscribe, store.getSnapshot, $937107406d6c3d9b$var$getDisabledSnapshot);
};
module.exports["useNativeEmbedCommentSupport"] = $937107406d6c3d9b$export$5ad16a2502716cba;

});

parcelRegister("jzubZ", function(module, exports) {

var $gczDe = parcelRequire("gczDe");


var $hXzKU = parcelRequire("hXzKU");


var $kDIns = parcelRequire("kDIns");


var $7AfoH = parcelRequire("7AfoH");


var $ayqMG = parcelRequire("ayqMG");


var $dQXFR = parcelRequire("dQXFR");

const $6c72ee9a775e4c5b$export$e5e59df64f812c64 = ({ pageId: pageId, validAnnotationsCallback: validAnnotationsCallback, triggerAnalyticsEvent: triggerAnalyticsEvent, setSelectionProps: setSelectionProps, setViewProps: setViewProps, updateDocument: updateDocument, isArchived: isArchived, setHoverProps: setHoverProps })=>{
    let updateSubscriber = (0, $gczDe.getRendererAnnotationEventEmitter)();
    if (!updateSubscriber?.off) updateSubscriber = undefined;
    return {
        selectionComponent: (0, $7AfoH.SelectionManager)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setSelectionProps: setSelectionProps,
            onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload()
        }),
        viewComponent: (0, $ayqMG.ViewManager)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setViewProps: setViewProps
        }),
        hoverComponent: (0, $dQXFR.HoverManager)({
            pageId: pageId,
            updateDocument: updateDocument,
            isArchived: isArchived,
            setHoverProps: setHoverProps,
            onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload()
        }),
        getState: (annotations, isNestedRender)=>(0, $kDIns.getRendererAnnotationStates)({
                annotations: annotations,
                pageId: pageId,
                validAnnotationsCallback: validAnnotationsCallback,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                isNestedRender: isNestedRender
            }),
        updateSubscriber: updateSubscriber,
        disallowOnWhitespace: true,
        isToolbarAbove: true,
        allowDraftMode: true,
        allowCommentsOnMedia: true
    };
};
module.exports["getRendererInlineCommentOptions"] = $6c72ee9a775e4c5b$export$e5e59df64f812c64;

});

parcelRegister("hXzKU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("2jady"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: true
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("2jady"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: true
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("2jady"))).CommentEditor,
    waitForNetworkOnline: true
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE1Y8M _30huDKOeNX _0bjKvDzXzM _2sNsIgmnOE _0jFU0VuNcX _24h04i2Njc _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("2jady", function(module, exports) {

let $1ae5481fcde9292b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1ae5481fcde9292b$var$load("7TMgc"),
    $1ae5481fcde9292b$var$load("bqdgP"),
    $1ae5481fcde9292b$var$load("ennNB"),
    $1ae5481fcde9292b$var$load("9Hr92"),
    $1ae5481fcde9292b$var$load("khIi2"),
    $1ae5481fcde9292b$var$load("eEjUf"),
    $1ae5481fcde9292b$var$load("9LDVS"),
    $1ae5481fcde9292b$var$load("kiMHu"),
    $1ae5481fcde9292b$var$load("7J1PC"),
    $1ae5481fcde9292b$var$load("446Ip"),
    $1ae5481fcde9292b$var$load("7I4uK"),
    $1ae5481fcde9292b$var$load("hUbK8"),
    $1ae5481fcde9292b$var$load("6wr18"),
    $1ae5481fcde9292b$var$load("5cIMo"),
    $1ae5481fcde9292b$var$load("2be0t"),
    $1ae5481fcde9292b$var$load("3Nd0K"),
    $1ae5481fcde9292b$var$load("cAUJ1"),
    $1ae5481fcde9292b$var$load("fOcPG"),
    $1ae5481fcde9292b$var$load("2DxYV"),
    $1ae5481fcde9292b$var$load("iOSMk"),
    $1ae5481fcde9292b$var$load("kQBNY"),
    $1ae5481fcde9292b$var$load("l7n3D"),
    $1ae5481fcde9292b$var$load("3Xf9v"),
    $1ae5481fcde9292b$var$load("2j57H"),
    $1ae5481fcde9292b$var$load("a0BE1"),
    $1ae5481fcde9292b$var$load("7XZVy"),
    $1ae5481fcde9292b$var$load("03zSE"),
    $1ae5481fcde9292b$var$load("b9Ivi"),
    $1ae5481fcde9292b$var$load("lPKve"),
    $1ae5481fcde9292b$var$load("dmzjI"),
    $1ae5481fcde9292b$var$load("jrIva"),
    $1ae5481fcde9292b$var$load("7OhMs"),
    $1ae5481fcde9292b$var$load("giX30"),
    $1ae5481fcde9292b$var$load("lUYNi"),
    $1ae5481fcde9292b$var$load("5Qxj8"),
    $1ae5481fcde9292b$var$load("fTxnK"),
    $1ae5481fcde9292b$var$load("6w94x"),
    $1ae5481fcde9292b$var$load("3nRrI"),
    $1ae5481fcde9292b$var$load("VXbA1"),
    $1ae5481fcde9292b$var$load("kfGHh"),
    $1ae5481fcde9292b$var$load("lIiD7"),
    $1ae5481fcde9292b$var$load("bJbqV"),
    $1ae5481fcde9292b$var$load("hLB9K"),
    $1ae5481fcde9292b$var$load("le1z7"),
    $1ae5481fcde9292b$var$load("4xsdA"),
    $1ae5481fcde9292b$var$load("dxcsb"),
    $1ae5481fcde9292b$var$load("7qcPK"),
    $1ae5481fcde9292b$var$load("DsM5z"),
    $1ae5481fcde9292b$var$load("lyagC"),
    $1ae5481fcde9292b$var$load("7SteV"),
    $1ae5481fcde9292b$var$load("Msrsx"),
    $1ae5481fcde9292b$var$load("cGkFm"),
    $1ae5481fcde9292b$var$load("dXuXG"),
    $1ae5481fcde9292b$var$load("3QQHc"),
    $1ae5481fcde9292b$var$load("ffEVr"),
    $1ae5481fcde9292b$var$load("a6kGP"),
    $1ae5481fcde9292b$var$load("dB5kj"),
    $1ae5481fcde9292b$var$load("jNr09"),
    $1ae5481fcde9292b$var$load("9xmQ5"),
    $1ae5481fcde9292b$var$load("g7Yjk"),
    $1ae5481fcde9292b$var$load("9TOep"),
    $1ae5481fcde9292b$var$load("bSSct"),
    $1ae5481fcde9292b$var$load("45r7q"),
    $1ae5481fcde9292b$var$load("hhss7"),
    $1ae5481fcde9292b$var$load("aAWLw"),
    $1ae5481fcde9292b$var$load("7EorR"),
    $1ae5481fcde9292b$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("7AfoH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dc72366b6b9218cc$export$6c8a5aaad13c9852 = ({ pageId: pageId, isArchived: isArchived, setSelectionProps: setSelectionProps, updateDocument: updateDocument, onCommentButtonMount: onCommentButtonMount })=>/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { range: range, draftRange: draftRange, wrapperDOM: wrapperDOM, isAnnotationAllowed: isAnnotationAllowed, onCreate: onCreate, onClose: onClose, applyDraftMode: applyDraftMode, removeDraftMode: removeDraftMode, inlineNodeTypes: inlineNodeTypes } = props;
        // Keep refs to applyDraftMode/removeDraftMode so that setSelectionOptionsForCreateEditor
        // always calls the latest Mounter instance's callbacks, even if Mounter unmounts and
        // remounts (e.g. after promoteHoverToDraft clears the type) without range/draftRange
        // changing (COMMENTS-6594).
        const applyDraftModeRef = (0, $cozmU.useRef)(applyDraftMode);
        const removeDraftModeRef = (0, $cozmU.useRef)(removeDraftMode);
        (0, $cozmU.useLayoutEffect)(()=>{
            applyDraftModeRef.current = applyDraftMode;
            removeDraftModeRef.current = removeDraftMode;
        }, [
            applyDraftMode,
            removeDraftMode
        ]);
        (0, $cozmU.useEffect)(()=>{
            setSelectionProps({
                pageId: pageId,
                isArchived: isArchived,
                updateDocument: updateDocument,
                range: range,
                draftRange: draftRange,
                wrapperDOM: wrapperDOM,
                isAnnotationAllowed: isAnnotationAllowed,
                onCreate: onCreate,
                onClose: onClose,
                applyDraftMode: (...args)=>applyDraftModeRef.current?.(...args),
                removeDraftMode: ()=>removeDraftModeRef.current?.(),
                inlineNodeTypes: inlineNodeTypes,
                onCommentButtonMount: onCommentButtonMount
            });
        // We only want to listen to changes that signifies a new selection
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            range,
            draftRange,
            wrapperDOM
        ]);
        return null;
    });
module.exports["SelectionManager"] = $dc72366b6b9218cc$export$6c8a5aaad13c9852;

});

parcelRegister("ayqMG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bSvtO = parcelRequire("bSvtO");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $cZa7r = parcelRequire("cZa7r");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9wGTI = parcelRequire("9wGTI");

const $913e742c4c6d0363$export$76599b5777b5fa44 = ({ pageId: pageId, updateDocument: updateDocument, setViewProps: setViewProps, isArchived: isArchived, annotations: annotations, clickElementTarget: clickElementTarget, deleteAnnotation: deleteAnnotation, getInlineNodeTypes: getInlineNodeTypes })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { newlyCreatedAnnotationId: newlyCreatedAnnotationId, storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { handleClose: handleSelectionClose, setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId, clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    // Clear stored comment data when annotation changes (before new component renders)
    (0, $cozmU.useEffect)(()=>{
        if (storedCommentData) {
            const currentAnnotationId = annotations?.[0]?.id;
            const storedAnnotationId = storedCommentData?.location?.inlineMarkerRef;
            // Clear stored data if we're viewing a different annotation
            if (currentAnnotationId && storedAnnotationId && currentAnnotationId !== storedAnnotationId) clearStoredCommentData();
        }
    }, [
        annotations,
        storedCommentData,
        clearStoredCommentData
    ]);
    (0, $cozmU.useEffect)(()=>{
        const wasHighlightClicked = Boolean(annotations.length && clickElementTarget);
        const handleSetViewProps = ()=>{
            // Below logic has been added to prevent the nested renderers like
            // excerpt/page properties macros to not set the wrong value of isArchived.
            // Thus, we need to setViewProps only when the "PageStatusQuery" defined in ViewPageComponent resolves
            if (isArchived !== undefined) setViewProps({
                pageId: pageId,
                updateDocument: updateDocument,
                isArchived: isArchived,
                annotations: annotations,
                clickElementTarget: clickElementTarget,
                deleteAnnotation: deleteAnnotation,
                wasHighlightClicked: wasHighlightClicked,
                getInlineNodeTypes: getInlineNodeTypes
            });
            // If we're showing this coming from a newly created comment, clear the props and succeed the experience
            if (annotations.length && annotations[0].id === newlyCreatedAnnotationId) {
                setNewlyCreatedAnnotationId(undefined);
                experienceTracker.succeed({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
                });
            }
        };
        // the if will be replaced with the new preemptive gate next/packages/annotation-provider-inline-comments/src/hooks/usePreemptiveGate.ts when cleanup platform_editor_comments_api_manager
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (hasContentChanged && wasHighlightClicked && !(0, $9wGTI.fg)('platform_editor_comments_api_manager')) {
            let abortedKeyboardExperience = false;
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
            /*
       * If a keyboard shortcut is used to navigate when the content has changed, we abort and restart
       * the experience on confirm because we can't predict if the user will confirm the navigation, or
       * how long the user will take to confirm.
       */ if (experienceState !== null && experienceState?.hasStopped === false && experienceState?.attributes?.entryPoint === 'comments-shortcuts/ViewCommentShortcutListener') {
                experienceTracker.abort({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    reason: 'Comment warning dialog displayed',
                    checkForTimeout: true,
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: 'annotation-provider-inline-comments/renderer/ViewManager'
                    }
                });
                abortedKeyboardExperience = true;
            }
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    if (abortedKeyboardExperience) {
                        experienceTracker.start({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                            attributes: {
                                annotationId: annotations.length && annotations[0].id,
                                entryPoint: 'annotation-provider-inline-comments/renderer/ViewManager',
                                pageClass: 'renderer'
                            }
                        });
                        experienceTracker.attachDebugPoint({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            message: 'Restarting experience after comment was discarded from comment warning dialog. Initial entrypoint: comments-shortcuts/ViewCommentShortcutListener'
                        });
                    }
                    resetContentChanged();
                    handleSelectionClose();
                    handleSetViewProps();
                }
            });
        } else handleSetViewProps();
    // We only want to listen to changes that signifies a new comment click
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        annotations,
        clickElementTarget
    ]);
    return null;
};
const $913e742c4c6d0363$export$e2fb22396d3bf4b8 = ({ pageId: pageId, updateDocument: updateDocument, setViewProps: setViewProps, isArchived: isArchived })=>/*#__PURE__*/ (0, $cozmU.memo)((viewComponentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($913e742c4c6d0363$export$76599b5777b5fa44, {
            pageId: pageId,
            updateDocument: updateDocument,
            setViewProps: setViewProps,
            isArchived: isArchived,
            ...viewComponentProps
        }));
module.exports["ViewManager"] = $913e742c4c6d0363$export$e2fb22396d3bf4b8;

});

parcelRegister("dQXFR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a7b8dfb125d18cb3$export$a74c7df2718eaab3 = ({ pageId: pageId, updateDocument: updateDocument, isArchived: isArchived, setHoverProps: setHoverProps, onCommentButtonMount: onCommentButtonMount })=>/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { range: range, isWithinRange: isWithinRange, wrapperDOM: wrapperDOM, isAnnotationAllowed: isAnnotationAllowed, onCreate: onCreate, onClose: onClose, applyDraftMode: applyDraftMode, removeDraftMode: removeDraftMode } = props;
        const handleClose = (0, $cozmU.useCallback)(()=>{
            onClose();
            setHoverProps(null);
        }, [
            onClose
        ]);
        (0, $cozmU.useEffect)(()=>{
            setHoverProps({
                pageId: pageId,
                updateDocument: updateDocument,
                isArchived: isArchived,
                range: range,
                wrapperDOM: wrapperDOM,
                isAnnotationAllowed: isAnnotationAllowed,
                onCreate: onCreate,
                onClose: handleClose,
                applyDraftMode: applyDraftMode,
                removeDraftMode: removeDraftMode,
                isWithinRange: isWithinRange,
                onCommentButtonMount: onCommentButtonMount
            });
        // We only want to listen to changes that signifies a new selection
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            range,
            wrapperDOM,
            isWithinRange
        ]);
        return null;
    });
module.exports["HoverManager"] = $a7b8dfb125d18cb3$export$a74c7df2718eaab3;

});

parcelRegister("cR8Mr", function(module, exports) {

var $c6zyu = parcelRequire("c6zyu");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $bcb18fc01161d294$var$commentsEnabled = (node)=>(0, $c6zyu.getNativeEmbedCommentSupportStore)().getSnapshot()(node);
const $bcb18fc01161d294$export$79acbd4eccd8a7d7 = ({ node: node, isCommentsEnabled: isCommentsEnabled = $bcb18fc01161d294$var$commentsEnabled })=>{
    if (node?.type.name !== 'extension') return false;
    try {
        return isCommentsEnabled(node) && (0, $6mKj3.expVal)('cc_maui_comments_on_charts_exp', 'isEnabled', false);
    } catch  {
        return false;
    }
};
const $bcb18fc01161d294$export$d104b29969768468 = (node, isCommentsEnabled = $bcb18fc01161d294$var$commentsEnabled)=>{
    try {
        return isCommentsEnabled(node);
    } catch  {
        return false;
    }
};
const $bcb18fc01161d294$export$495dd96191bdec77 = (node, isCommentsEnabled = $bcb18fc01161d294$var$commentsEnabled)=>$bcb18fc01161d294$export$79acbd4eccd8a7d7({
        node: node,
        isCommentsEnabled: isCommentsEnabled
    });
const $bcb18fc01161d294$export$381515fbc7f70968 = (node)=>{
    if (node.type.name === 'extension' && node.attrs.extensionKey === 'native-embed:maui' && (0, $9wGTI.fg)('cc_maui_annotations_on_extensions')) // Keep saved chart comments accessible when the toolbar's creation experiment is off.
    return $bcb18fc01161d294$export$d104b29969768468(node);
    return $bcb18fc01161d294$export$495dd96191bdec77(node);
};
module.exports["isRendererExtensionCommentBlockNodeSupported"] = $bcb18fc01161d294$export$d104b29969768468;
module.exports["isExtensionCommentBlockNodeSupported"] = $bcb18fc01161d294$export$495dd96191bdec77;
module.exports["isEditorExtensionCommentBlockNodeSupported"] = $bcb18fc01161d294$export$381515fbc7f70968;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $flWvL = parcelRequire("flWvL");


var $7bpSh = parcelRequire("7bpSh");


var $5glkr = parcelRequire("5glkr");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage);
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const contentModeFragmentData = (0, $cozmU.useContext)((0, $7bpSh.ContentModeFragmentContext));
    const editorContentModeFragmentResult = (0, $5glkr.useContentModeFragment)({
        contentId: contentId
    });
    const contentModeQueryResult = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: contentId && (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
            ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                contentId: contentId
            }),
            isDraft: isDraft
        } : {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: editorContentModeFragmentResult.isProvided || !contentId || Boolean(contentModeFragmentData) // avoid starting network flow
        ,
        __callerPackage__: "editor-content-mode-button"
    });
    const { data: data, error: error } = editorContentModeFragmentResult.isProvided ? editorContentModeFragmentResult : contentModeQueryResult;
    const loading = editorContentModeFragmentResult.isLoading || contentModeQueryResult.loading;
    let serverModeRaw;
    const contentProps = contentModeFragmentData ? contentModeFragmentData?.contentProperties : data?.content?.nodes?.[0]?.contentProperties;
    if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
    else serverModeRaw = contentProps?.latest?.contentMode;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            isLoading: contentModeFragmentData ? false : Boolean(loading),
            error: contentModeFragmentData ? null : error ?? null
        }), [
        mode,
        loading,
        error,
        contentModeFragmentData
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<11e8316517ac59e0b0326a7aa3a855c6>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("5glkr", function(module, exports) {

var $3Zrod = parcelRequire("3Zrod");


var $hX2PJ = parcelRequire("hX2PJ");

// useEditorContentModeValueQuery's selection for EditorContentUnifiedQuery, with isDraft as
// !isLivePage, as it is on the editor routes; same fields, so both share the store records.
const $de3b8e686834334b$var$contentModeFragmentNode = (0, $3Zrod.default);
function $de3b8e686834334b$export$e7a4877827f2da04({ contentId: contentId }) {
    return (0, $hX2PJ.useEditorContentFragment)('contentModeFragment', $de3b8e686834334b$var$contentModeFragmentNode, {
        contentId: contentId,
        mapData: (value)=>({
                content: {
                    nodes: [
                        value
                    ]
                }
            })
    });
}
module.exports["useContentModeFragment"] = $de3b8e686834334b$export$e7a4877827f2da04;

});

parcelRegister("3Zrod", function(module, exports) {
/**
 * @generated SignedSource<<3afdbcdd23f87129101f7fe0014c14a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a2d4b5b24b2d54e$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLivePage"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "catchTo": "RESULT"
        },
        "name": "useContentModeFragment_content",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "condition": "isLivePage",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "PublishedContentProperties",
                                "kind": "LinkedField",
                                "name": "latest",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "condition": "isLivePage",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "DraftContentProperties",
                                "kind": "LinkedField",
                                "name": "draft",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$2a2d4b5b24b2d54e$var$node.hash = "09f91bca2c7af89d06b97681af8d429b";
var $2a2d4b5b24b2d54e$export$2e2bcd8739ae039 = $2a2d4b5b24b2d54e$var$node;
module.exports["default"] = $2a2d4b5b24b2d54e$export$2e2bcd8739ae039;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("2TjtA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $8Kasn = parcelRequire("8Kasn");


var $hEeUR = parcelRequire("hEeUR");


var $1P7Cq = parcelRequire("1P7Cq");


var $7oNjV = parcelRequire("7oNjV");


var $hBmKH = parcelRequire("hBmKH");


var $KndLU = parcelRequire("KndLU");

const $37b1f85e2c625feb$var$DEFAULT_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: [
        {
            type: 'paragraph',
            content: []
        }
    ]
};
const $37b1f85e2c625feb$export$bfa9bef3db8b5c11 = (node)=>({
        adfDocument: node?.parameters?.nestedContent || $37b1f85e2c625feb$var$DEFAULT_DOCUMENT,
        appearance: 'max'
    });
const $37b1f85e2c625feb$var$collapsedEmptyLists = null;
const $37b1f85e2c625feb$var$stableTableHydrationLayout = null;
const $37b1f85e2c625feb$export$c71052e15da9d2c0 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { allowAnnotations: allowAnnotations, annotationProvider: annotationProvider, appearance: appearance, contentId: contentId, contentMode: contentMode, dataProviders: dataProviders, adfDocument: adfDocument, eventHandlers: eventHandlers, extensionHandlers: extensionHandlers, onSetLinkTarget: onSetLinkTarget } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            skipValidation: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const validationContextValue = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_4ixK1yYbGa _4hO0hfYbGa _44jcBZdnbC _3tyuUtdnbC",
            "_0glMfrogpp _0awIj60ATe"
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== adfDocument || $[3] !== allowAnnotations || $[4] !== annotationProvider || $[5] !== appearance || $[6] !== contentId || $[7] !== contentMode || $[8] !== dataProviders || $[9] !== eventHandlers || $[10] !== extensionHandlers || $[11] !== onSetLinkTarget) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Kasn.ValidationContextProvider), {
            value: validationContextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
            annotationProvider: annotationProvider,
            allowAnnotations: allowAnnotations,
            appearance: appearance,
            allowHeadingAnchorLinks: false,
            contentId: contentId,
            dataProviders: dataProviders,
            document: adfDocument,
            extensionHandlers: extensionHandlers,
            contentMode: contentMode,
            eventHandlers: eventHandlers,
            onSetLinkTarget: onSetLinkTarget
        }))));
        $[2] = adfDocument;
        $[3] = allowAnnotations;
        $[4] = annotationProvider;
        $[5] = appearance;
        $[6] = contentId;
        $[7] = contentMode;
        $[8] = dataProviders;
        $[9] = eventHandlers;
        $[10] = extensionHandlers;
        $[11] = onSetLinkTarget;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
}; /**
    * Server/first-hydration renderer for the non-recursive LCM SSR path. It intentionally avoids the
    * client provider hooks because they can start queries that are unnecessary when no nested
    * extension is present, and it passes no nested handlers: without recursive SSR there is nothing
    * inside the LCM that the SSR handler set would own.
    */ 
const $37b1f85e2c625feb$export$68180e79369d4d34 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { contentId: contentId, contentMode: contentMode, node: node } = t0;
    let t1;
    if ($[0] !== node) {
        t1 = $37b1f85e2c625feb$export$bfa9bef3db8b5c11(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const { adfDocument: adfDocument, appearance: appearance } = t1;
    let t2;
    if ($[2] !== adfDocument || $[3] !== appearance || $[4] !== contentId || $[5] !== contentMode) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37b1f85e2c625feb$export$c71052e15da9d2c0, {
            adfDocument: adfDocument,
            appearance: appearance,
            contentId: contentId,
            contentMode: contentMode
        });
        $[2] = adfDocument;
        $[3] = appearance;
        $[4] = contentId;
        $[5] = contentMode;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
}); /**
     * Keeps the nested ADFRenderer mounted across the SSR-handler to manifest-ready handoff. The first
     * client render uses exactly the server configuration; client-only providers are attached in place
     * only after both Confluence hydration and the LCM manifest preload have completed.
     *
     * `dataProviders` is deliberately NOT deferred with the rest of the client config. Nested extensions
     * reach their manifests through the factory's `extensionProvider`, and platform's `WithProviders`
     * subscribes in its constructor without ever re-subscribing, so a factory attached after mount can
     * never reach the extensions already rendered — every `null`-returning handler would be left with a
     * dead fall-through and no way to reach the manifest. The factory is therefore supplied from the
     * very first render, on the server and on the client alike, so both sides agree.
     */ 
const $37b1f85e2c625feb$export$7fbd5941a148d056 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { clientAnnotationProvider: clientAnnotationProvider, clientExtensionHandlers: clientExtensionHandlers, clientHydrationReady: clientHydrationReady, contentId: contentId, contentMode: contentMode, extensionHandlers: extensionHandlers, node: node } = t0;
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const [clientConfig, setClientConfig] = (0, $cozmU.useState)();
    let t1;
    if ($[0] !== node) {
        t1 = $37b1f85e2c625feb$export$bfa9bef3db8b5c11(node);
        $[0] = node;
        $[1] = t1;
    } else t1 = $[1];
    const { adfDocument: adfDocument, appearance: appearance } = t1;
    const dataProviders = (0, $KndLU.useNestedLcmProviderFactory)();
    const shouldLoadClientConfig = clientHydrationReady && !renderServerPlaceholder;
    const t2 = clientConfig?.allowAnnotations;
    const t3 = clientConfig?.annotationProvider;
    const t4 = clientConfig?.eventHandlers;
    const t5 = clientConfig ? clientExtensionHandlers : extensionHandlers;
    const t6 = clientConfig?.onSetLinkTarget;
    let t7;
    if ($[2] !== adfDocument || $[3] !== appearance || $[4] !== contentId || $[5] !== contentMode || $[6] !== dataProviders || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($37b1f85e2c625feb$export$c71052e15da9d2c0, {
            adfDocument: adfDocument,
            allowAnnotations: t2,
            annotationProvider: t3,
            appearance: appearance,
            contentId: contentId,
            contentMode: contentMode,
            dataProviders: dataProviders,
            eventHandlers: t4,
            extensionHandlers: t5,
            onSetLinkTarget: t6
        });
        $[2] = adfDocument;
        $[3] = appearance;
        $[4] = contentId;
        $[5] = contentMode;
        $[6] = dataProviders;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== adfDocument || $[14] !== clientAnnotationProvider || $[15] !== contentId || $[16] !== shouldLoadClientConfig) {
        t8 = shouldLoadClientConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7oNjV.NBMRendererHydrationClientEnhancer), {
            adfDocument: adfDocument,
            annotationProvider: clientAnnotationProvider,
            contentId: contentId,
            onLoad: setClientConfig
        }) : null;
        $[13] = adfDocument;
        $[14] = clientAnnotationProvider;
        $[15] = contentId;
        $[16] = shouldLoadClientConfig;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== t7 || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBmKH.NestedLcmHierarchyContext).Provider, {
            value: true
        }, t7, t8);
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
});
module.exports["resolveNBMRenderConfig"] = $37b1f85e2c625feb$export$bfa9bef3db8b5c11;
module.exports["NBMRendererContent"] = $37b1f85e2c625feb$export$c71052e15da9d2c0;
module.exports["NBMRendererServer"] = $37b1f85e2c625feb$export$68180e79369d4d34;
module.exports["NBMRendererHydrationBridge"] = $37b1f85e2c625feb$export$7fbd5941a148d056;

});

parcelRegister("iy2dR", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $79LXc = parcelRequire("79LXc");

const $b57efbc43dea6d2e$export$5a1bd65a7ea6f802 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { adfDocument: adfDocument, contentId: contentId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== adfDocument || $[1] !== contentId || $[2] !== createAnalyticsEvent) {
        t1 = ()=>{
            if (!contentId || !createAnalyticsEvent || !adfDocument) return;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "rendererInitialised",
                    actionSubject: "legacyContentMacro",
                    source: "legacyContentMacro",
                    attributes: {
                        objectId: contentId,
                        pageElementCounts: (0, $79LXc.getPageElementCounts)(adfDocument)
                    }
                }
            }).fire();
        };
        t2 = [
            adfDocument,
            contentId,
            createAnalyticsEvent
        ];
        $[0] = adfDocument;
        $[1] = contentId;
        $[2] = createAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
module.exports["useLegacyContentMacroRendererAnalytics"] = $b57efbc43dea6d2e$export$5a1bd65a7ea6f802;

});

parcelRegister("7oNjV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jNKuq = parcelRequire("jNKuq");


var $iy2dR = parcelRequire("iy2dR");

const $925a9bbfc58ef16a$export$37957a653a6adcbf = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { adfDocument: adfDocument, annotationProvider: annotationProvider, contentId: contentId, onLoad: onLoad } = t0;
    const { eventHandlers: eventHandlers, onSetLinkTarget: onSetLinkTarget } = (0, $jNKuq.useExternalLinkHandlers)();
    let t1;
    if ($[0] !== annotationProvider || $[1] !== eventHandlers || $[2] !== onSetLinkTarget) {
        t1 = {
            allowAnnotations: true,
            annotationProvider: annotationProvider,
            eventHandlers: eventHandlers,
            onSetLinkTarget: onSetLinkTarget
        };
        $[0] = annotationProvider;
        $[1] = eventHandlers;
        $[2] = onSetLinkTarget;
        $[3] = t1;
    } else t1 = $[3];
    const clientConfig = t1;
    let t2;
    let t3;
    if ($[4] !== clientConfig || $[5] !== onLoad) {
        t2 = ()=>{
            onLoad(clientConfig);
        };
        t3 = [
            clientConfig,
            onLoad
        ];
        $[4] = clientConfig;
        $[5] = onLoad;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[8] !== adfDocument || $[9] !== contentId) {
        t4 = {
            adfDocument: adfDocument,
            contentId: contentId
        };
        $[8] = adfDocument;
        $[9] = contentId;
        $[10] = t4;
    } else t4 = $[10];
    (0, $iy2dR.useLegacyContentMacroRendererAnalytics)(t4);
    return null;
};
module.exports["NBMRendererHydrationClientEnhancer"] = $925a9bbfc58ef16a$export$37957a653a6adcbf;

});


//# sourceMappingURL=LegacyContentExtensionHandler.68ce4b68.js.map
